/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".sticky-bottom[_ngcontent-%COMP%]{position:-webkit-sticky!important;position:sticky!important;bottom:0}.footColor[_ngcontent-%COMP%]{background-color:#f0f8ff}.minHeight[_ngcontent-%COMP%]{min-height:93vh}.navbar[_ngcontent-%COMP%]{margin-bottom:10px}"];
export { styles as styles };

